import { gql } from 'graphql-request'

export const SALVAR_USUARIO = gql`
  mutation salvarUsuario(
    $usuario: UsuarioInput!
    $cargos: [CargoInput]!
    $infos: InfoUsuarioInput
  ) {
    salvarUsuario(usuario: $usuario, cargos: $cargos, infos: $infos) {
      id
      nome
      email
      cpf
      tipoDocumento {
        id
      }
      telefones
      celulares
      tiposAcesso {
        id
        produto {
          id
        }
      }
      funcionalidades {
        id
        chave
        nome
        descricao
      }
      tipo {
        id
      }
      idioma {
        id
      }
      marcas {
        id
      }
    }
  }
`
